import React, {useEffect, useState} from 'react';
import {Box, Button, FormControl, FormHelperText, FormLabel, Grid, IconButton, Modal, TextareaAutosize, TextField, Tooltip, Typography} from "@mui/material";
import FormDateInput from "../../../../components/form/FormDateInput";
import {MdDeleteOutline} from "react-icons/md";
import {confirmation, handleDelete, parseTime, timeSlots} from "../../../../services/utills";
import * as yup from "yup";
import * as Yup from "yup";
import {useFormik} from "formik";
import {storeBlockHour, storeStaffBreakTime, UpdateBlockHour} from "../../../../store/clinics/clinicSettings/business-hours";
import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import CustomButtoncolor from '../../../../components/custom-button/customColorButton';
import Waveloading from '../../../loading/Waveloading';
import ClearIcon from '@mui/icons-material/Clear';
import { MdModeEditOutline } from "react-icons/md";
import toast from "react-hot-toast";
import { getBlockhourId } from '../../../../store/crm/calender';
/* ── Theme tokens (match the redesigned burgundy/pink app theme) ── */
const PINK_BG = '#FAEFF5';
const PINK_BORDER = '#F0CDDB';
const BURGUNDY = '#A72C68';
const BURGUNDY_DARK = '#921F58';
const TEXT_DARK = '#1a1a2e';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 480,
    maxWidth: '95vw',
    bgcolor: '#fff',
    borderRadius: '16px',
    boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
    overflow: 'hidden',
    outline: 'none',
  };

const fieldSx = {
    background: '#fff',
    borderRadius: '10px',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        '& fieldset': { borderColor: PINK_BORDER },
        '&:hover fieldset': { borderColor: BURGUNDY },
        '&.Mui-focused fieldset': { borderColor: BURGUNDY, borderWidth: '1.5px' },
    },
};

  const labelStyles ={
    color: TEXT_DARK,
    fontSize:'13px',
    fontWeight: 600,
    mb:'6px',
    "&.Mui-focused": {
        color: `${TEXT_DARK}!important`,
    }
}
const StaffUpdateModal = ({ onRescheduleSuccess, id }) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    
    // ✅ Formik Initialization
    const formik = useFormik({
        initialValues: {
            date: '',
            start_time: '',
            end_time: '',
            notes: '',
        },
        validationSchema: yup.object({
            notes: yup.string().min(3, "Notes is Too Short").required('Notes is required'),
            date: yup.date().typeError("Staff holiday date is required").required("Staff holiday date is required"),
            start_time: yup.date().transform((value, originalValue) => originalValue ? parseTime(originalValue) : null)
                .required("Start time is required").typeError("Start time is required"),
            end_time: yup.date().transform((value, originalValue) => originalValue ? parseTime(originalValue) : null)
                .required("End time is required").typeError("End time is required")
                .min(yup.ref("start_time"), "End time must be after start time"),
        }),

        onSubmit: async (data, { setFieldTouched, setFieldError }) => {
            setLoading(true)
            setOpen(false);
            setTimeout(async () => {
            let res = await dispatch(UpdateBlockHour({ ...data,id }))
          
            if (res?.payload?.errors) {
                const { errors } = res?.payload
                if (errors) toast.error(errors, { duration: 5000 });

                ["date", "start_time", "end_time", "notes"].forEach(field => {
                    if (errors?.[field]) {
                        setFieldTouched(field, true);
                        setFieldError(field, errors?.[field]);
                    }
                }); 

                setLoading(false);
            } else if (res?.payload?.success === "true") {
                formik.resetForm();
                onRescheduleSuccess && onRescheduleSuccess();
                setLoading(false); 
                // setOpen(false);
                // toast.success(res?.payload?.success?.message) 
            }
        }, 5000); 
        },
    });

    // ✅ Fetch Data and Set Formik Values
    const handleOpen = async () => {
       
        setLoading(true);

        let res = await dispatch(getBlockhourId(id));
        //console.log("Data comes", res);
       
        if (res?.payload?.data?.id) {
            formik.setValues({
                date: res.payload.data.date || '',
                start_time: res.payload.data.start_time || '',
                end_time: res.payload.data.end_time || '',
                notes: res.payload.data.notes || ''
            });
        }

        setLoading(false);
        setOpen(true);
    };

    return (
        <>
            {/* Edit Button — styled to match the calendar's delete action */}
            <Tooltip title="Edit">
                <IconButton
                    size="small"
                    onClick={handleOpen}
                    sx={{
                        width: 26, height: 26,
                        background: '#fff',
                        border: `1px solid ${PINK_BORDER}`,
                        '&:hover': { background: PINK_BG, borderColor: BURGUNDY },
                    }}
                >
                    <MdModeEditOutline color={BURGUNDY} fontSize={'16px'} />
                </IconButton>
            </Tooltip>

            {loading && <Waveloading fullSize />}

            {/* Modal */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <Box sx={style}>
                    {/* Header */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            px: 3,
                            py: 2,
                            borderBottom: `1px solid ${PINK_BORDER}`,
                        }}
                    >
                        <Box
                            sx={{
                                width: 38, height: 38,
                                borderRadius: '10px',
                                background: PINK_BG,
                                border: `1px solid ${PINK_BORDER}`,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}
                        >
                            <MdModeEditOutline color={BURGUNDY} fontSize={'20px'} />
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={{ fontSize: '17px', fontWeight: 700, color: TEXT_DARK, lineHeight: 1.2 }}>
                                Update Block Hours
                            </Typography>
                            <Typography sx={{ fontSize: '12px', color: '#6B7280', mt: '2px' }}>
                                Edit the blocked time range and notes
                            </Typography>
                        </Box>
                        <IconButton
                            size="small"
                            onClick={() => setOpen(false)}
                            sx={{
                                color: '#6B7280',
                                borderRadius: '8px',
                                '&:hover': { background: PINK_BG, color: BURGUNDY },
                            }}
                        >
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    </Box>

                    {/* Body */}
                    <Box sx={{ px: 3, py: 2.5 }}>
                        <form onSubmit={formik.handleSubmit}>
                            <Grid container sx={{ justifyContent: 'space-between', display: 'flex' }}>
                                {/* Date Input */}
                                <Grid item xs={12} lg={12} mb={'16px'}>
                                    <FormDateInput
                                        name="date"
                                        errors={formik.errors}
                                        touched={formik.touched}
                                        values={formik.values}
                                        handleChange={formik.handleChange}
                                    />
                                </Grid>

                                {/* Start Time */}
                                <Grid item xs={12} lg={12} mb={'16px'}>
                                    <FormLabel sx={{ ...labelStyles, display: 'block' }}>Start Time</FormLabel>
                                    <Autocomplete
                                        name="start_time"
                                        options={timeSlots}
                                        getOptionLabel={(option) => option}
                                        value={formik.values.start_time}
                                        renderInput={(params) => (
                                            <TextField {...params} sx={fieldSx} placeholder={"Start Time"} />
                                        )}
                                        onChange={(event, newValue) => formik.setFieldValue("start_time", newValue)}
                                    />
                                    {formik.errors.start_time && formik.touched.start_time &&
                                        <FormHelperText sx={{ color: '#CB3838', width: 'max-content', mx: 0 }}>
                                            {formik.errors.start_time}
                                        </FormHelperText>
                                    }
                                </Grid>

                                {/* End Time */}
                                <Grid item xs={12} lg={12} mb={'16px'}>
                                    <FormLabel sx={{ ...labelStyles, display: 'block' }}>End Time</FormLabel>
                                    <Autocomplete
                                        name="end_time"
                                        options={timeSlots}
                                        getOptionLabel={(option) => option}
                                        value={formik.values.end_time}
                                        renderInput={(params) => (
                                            <TextField {...params} sx={fieldSx} placeholder={"End Time"} />
                                        )}
                                        onChange={(event, newValue) => formik.setFieldValue("end_time", newValue)}
                                    />
                                    {formik.errors.end_time && formik.touched.end_time &&
                                        <FormHelperText sx={{ color: '#CB3838', width: 'max-content', mx: 0 }}>
                                            {formik.errors.end_time}
                                        </FormHelperText>
                                    }
                                </Grid>

                                {/* Notes */}
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <FormLabel sx={{ ...labelStyles }}>Notes</FormLabel>
                                        <textarea
                                            className="MuiInputBase-input MuiOutlinedInput-input"
                                            rows={3}
                                            name="notes"
                                            value={formik.values.notes}
                                            onChange={formik.handleChange}
                                            style={{
                                                width: '100%',
                                                resize: 'vertical',
                                                padding: '10px',
                                                border: `1px solid ${PINK_BORDER}`,
                                                borderRadius: '10px',
                                                fontFamily: 'inherit',
                                                fontSize: '0.95rem',
                                                outlineColor: BURGUNDY,
                                            }}
                                        />
                                        {formik.errors.notes && formik.touched.notes &&
                                            <FormHelperText sx={{ color: '#CB3838', width: 'max-content', mx: 0 }}>
                                                {formik.errors.notes}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                </Grid>

                                {/* Save Button */}
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: '20px' }}>
                                    <Button
                                        onClick={() => setOpen(false)}
                                        sx={{
                                            height: '44px',
                                            px: 3,
                                            borderRadius: '10px',
                                            textTransform: 'capitalize',
                                            backgroundColor: '#EB5757',
                                            color: '#fff',
                                            border: '1px solid #EB5757',
                                            boxShadow: 'none',
                                            '&:hover': {
                                                backgroundColor: '#fff',
                                                color: '#EB5757',
                                                border: '1px solid #EB5757',
                                                boxShadow: 'none',
                                            },
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        sx={{
                                            height: '44px',
                                            px: 3,
                                            borderRadius: '10px',
                                            textTransform: 'capitalize',
                                            fontWeight: 600,
                                            color: '#fff',
                                            background: "linear-gradient(135deg, #27AE60 0%, #1E8449 100%)",
                                            border: '1px solid #27AE60',
                                            boxShadow: 'none',
                                            '&:hover': {
                                                background: '#219653',
                                                color: '#fff',
                                                border: '1px solid #27AE60',
                                                boxShadow: 'none',
                                            },
                                        }}
                                        type="submit"
                                    >
                                        Update Block Hours
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};


export default StaffUpdateModal;